module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div')
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7d834b4c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/root/EdSocket.vue
// module id = 1563
// module chunks = 45